import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '倉庫カレンダー',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  rolesOnly: ['admin', 'FCJapan'],
};
